<template>
    <v-content :style="{'background-image': `url('`+ require('../assets/bg-login.jpg') +`')`}"
               style="background-size: cover">
        <Header></Header>
        <v-layout justify-center>
            <v-flex xs12 style="background-color: #527281">
                <v-content>
                    <v-layout px-12 py-3>
                        <v-flex shrink style="text-align: left;">
                            <v-btn text small style="color: white;font-size: 18px" @click="$router.push('/home').catch(err => {})">
                                หน้าแรก
                            </v-btn>
                        </v-flex>
                        <v-icon style="color: white">play_arrow</v-icon>
                        <v-flex shrink style="text-align: left;">
                            <v-btn text small style="color: white;font-size: 18px">แก้ไขโปรไฟล์</v-btn>
                        </v-flex>
                    </v-layout>
                </v-content>
            </v-flex>
        </v-layout>
        <v-layout justify-center>
            <v-flex xs12 sm10 md7 class="my-12 mb-4">
                <v-card class="py-12" style="border-radius: 25px;background: white; box-shadow: #2c3e50">
                    <v-layout>
                        <v-flex class="pb-6" style="font-size: 32px; color: #527281">
                            แก้ไขโปรไฟล์
                        </v-flex>
                    </v-layout>
                    <v-layout justify-center>
                        <v-flex xs10 class="" style="font-size: 24px">
                            <v-form>
                                <v-layout class="form-edit-user" style="font-size: 18px">
                                    <v-flex md3 class="mr-4" style="text-align: right">
                                        ชื่อ :
                                    </v-flex>
                                    <v-flex md8>
                                        <v-text-field
                                                v-model="form.firstname"
                                                background-color="#E5E5E5"
                                                solo
                                                :rules="fnameRules"
                                                required>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="form-edit-user" style="font-size: 18px">
                                    <v-flex md3 class="mr-4" style="text-align: right">
                                        นามสกุล :
                                    </v-flex>
                                    <v-flex md8>
                                        <v-text-field
                                                v-model="form.lastname"
                                                background-color="#E5E5E5"
                                                solo
                                                :rules="lnameRules"
                                                required>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="form-edit-user" style="font-size: 18px">
                                    <v-flex md3 class="mr-4" style="text-align: right">
                                        อีเมล :
                                    </v-flex>
                                    <v-flex md8>
                                        <v-text-field
                                                v-model="form.email"
                                                background-color="#E5E5E5"
                                                solo
                                                :rules="emailRules"
                                                required>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="form-edit-user" style="font-size: 18px">
                                    <v-flex md3 class="mr-4" style="text-align: right">
                                        หมายเลขโทรศัพท์ :
                                    </v-flex>
                                    <v-flex md8>
                                        <v-text-field
                                                v-model="form.tel"
                                                background-color="#E5E5E5"
                                                solo
                                                :rules="numberRules"
                                                required>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="form-edit-user" style="font-size: 18px">
                                    <v-flex md3 class="mr-4" style="text-align: right">
                                        หมายเลขโทรศัพท์หน่วยงาน :
                                    </v-flex>
                                    <v-flex md8>
                                        <v-text-field
                                                v-model="form.tel_organization"
                                                background-color="#E5E5E5"
                                                solo
                                                :rules="numberRules"
                                                required>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="form-edit-user" style="font-size: 18px">
                                    <v-flex md3 class="mr-4" style="text-align: right">
                                        หน่วยงาน :
                                    </v-flex>
                                    <v-flex md8>
                                        <v-select
                                                :menu-props="{ bottom: true, offsetY: true }"
                                                v-model="form.organization_id"
                                                :items="organitzation"
                                                item-text="organization_name"
                                                item-value="organization_id"
                                                background-color="#E5E5E5"
                                                solo
                                                :rules="departmentRules"
                                                required>
                                        </v-select>
                                    </v-flex>
                                </v-layout>
<!--                                <v-layout class="form-edit-user" style="font-size: 18px">-->
<!--                                    <v-flex md3 class="mr-4" style="text-align: right">-->
<!--                                        รหัสผู้ใช้งาน :-->
<!--                                    </v-flex>-->
<!--                                    <v-flex md8>-->
<!--                                        <v-text-field-->
<!--                                                v-model="form.username"-->
<!--                                                background-color="#E5E5E5"-->
<!--                                                solo-->
<!--                                                :rules="passwordRules"-->
<!--                                                required>-->
<!--                                        </v-text-field>-->
<!--                                    </v-flex>-->
<!--                                </v-layout>-->
                            </v-form>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout class="mb-12" justify-center>
            <v-flex shrink class="ma-2">
                <v-btn style="background-color: #BDBDBD; color: white;border-radius: 25px;" @click="$router.push('/home').catch(err => {})">ย้อนกลับ</v-btn>
            </v-flex>
            <v-flex shrink class="ma-2">
                <v-btn style="background-color: #527281; color: white;border-radius: 25px;" @click="editUser()">ยืนยันการแก้ไขโปรไฟล์</v-btn>
            </v-flex>
        </v-layout>

        <loading
                color="#527281"
                :active.sync="isLoading"
                :can-cancel="false"
                :is-full-page="fullPage"
        ></loading>

        <Footer></Footer>
    </v-content>
</template>

<script>
    import Header from "../components/Header";
    import Footer from "../components/Footer";
    import validate from "../utils/validate";
    import { mapState } from "vuex";
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: "EditProfileUser",
        components: {
            Footer,
            Header,
            Loading
        },
        computed: {
            // Map Vuex state.
            ...mapState({
                form: state => {
                    return {
                        ...state.Auth.user,
                        organization_id: `${state.Auth.user.organization_id}`
                    }
                },
                organization: state => {
                    return state.Common.organization
                },
                token: state => {
                    return state.Auth.accessToken
                },
            })
        },
        created() {
            this.isLoading = true;
            setTimeout(() => {
                this.getOrganizationAll();
                this.isLoading = false;
            })
        },
        data: () => ({
            isLoading: false,
            fullPage: true,
            organitzation: [],

            fnameRules: [
                v => validate.required(v, "ชื่อ"),
            ],
            lnameRules: [
                v => validate.required(v, "นามสกุล"),
            ],
            emailRules: [
                v => validate.validEmail(v, "email"),
                v => validate.required(v, "email"),
            ],
            numberRules: [
                v => validate.required(v, "หมายเลขโทรศัพท์"),
            ],
            departmentRules: [
                v => validate.required(v, "หน่วยงาน"),
            ],
            passwordRules: [
                v => validate.required(v, "password"),
            ],
            ConfirmPasswordRules: [
                v => validate.confirmPassword(v, "confirm_Password"),
            ],

        }),
        methods: {
            getOrganizationAll() {
                this.$store.dispatch('Common/getOrganizationAll').then(res => {
                    res.forEach(dataOrganitzation => {
                        this.organitzation.push({
                            organization_id: `${dataOrganitzation.id}`,
                            organization_name: `${dataOrganitzation.name}`
                        });
                    })
                })
            },
            editUser() {
                this.isLoading = true;
                let data = {
                    id: this.form.id,
                    firstname: this.form.firstname,
                    lastname: this.form.lastname,
                    email: this.form.email,
                    tel: this.form.tel,
                    tel_organization: this.form.tel_organization,
                    organization_id: this.form.organization_id,
                    username: this.form.username,
                };
                this.$store.dispatch('Auth/editUser', data)
                    .then(res => {
                        alert('แก้ไขข้อมูลเรียบร้อยแล้ว')
                        this.isLoading = false;
                    })
                    .catch(err => {
                        alert('แก้ไขข้อมูลไม่สำเร็จ')
                        this.isLoading = false;
                    })
            },
        }
    }
</script>

<style lang="scss">
    .form-edit-user {
        .v-text-field.v-text-field--solo .v-input__control {
            min-height: 35px !important;
        }

        .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
            border-radius: 20px;
            box-shadow: unset;
        }

        .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
            color: #527281;
        }

        .theme--light.v-select .v-select__selections {
            color: #527281;
        }
    }

</style>
